<template>
    <div class="cont">
        <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
        />
        <draggable
            v-model="entries"
            @change="entriesChanged()"
            handle=".entry_handle"
            style="position: relative"
        >
            <transition-group tag="div">
                <div
                    v-for="(e, index) in entries"
                    :key="e.uuid"
                    style="position: relative"
                >
                    <entry
                        :newData="edit_entries.new_entries[e.id]"
                        :copied_entry="e.copied_entry"
                        :getTariff="getTariff"
                        :newTariff="newTariff"
                        :uuidOffer="uuidOffer"
                        :units="units"
                        :premium="premium"
                        :is="e.component"
                        :id="e.id"
                        :index="index"
                        :default_dph="default_dph"
                        :entries_length="entries.length"
                        :entry_title_image="
                            entries_title_image
                                ? entries_title_image[e.data.id]
                                : null
                        "
                        :entry_title_image_mobile="
                            entries_title_image_mobile
                                ? entries_title_image_mobile[e.data.id]
                                : null
                        "
                        :copy_title_image="e.title_file ? e.title_file : null"
                        :copy_title_image_mobile="
                            e.title_file_mobile ? e.title_file_mobile : null
                        "
                        @remove="removeEntry($event)"
                        @data="dataEntry($event, e.id)"
                        :is_paid="is_paid"
                        @copy_entry="copy_entry($event)"
                        @moveUp="moveUp($event)"
                        @moveDown="moveDown($event)"
                    />
                </div>
            </transition-group>
        </draggable>
        <div class="add_entry mt-4" @click="addEntry(true)">
            + Pridať ďalšiu položku
        </div>
        <div class="bottom">
            <div class="left"></div>
            <div class="right">
                <div class="top">
                    <div
                        class="form-group mb-0 d-flex"
                        style="align-items: flex-end"
                    >
                        <input
                            v-model="showDiscount"
                            @input="values.discount = 0"
                            @change="price_text()"
                            type="checkbox"
                            class="toggle"
                        />
                        <label class="block mb-0 mr-2">
                            Pridať celkovú zľavu
                        </label>
                        <money
                            v-bind="suffix.discount"
                            v-show="showDiscount"
                            v-model="values.discount"
                            type="text"
                            class="zlava"
                        ></money>
                    </div>
                </div>

                <div class="price">
                    <div class="one" v-if="this.price_without_dph() != null">
                        {{
                            this.showDiscount
                                ? "Celková cena bez DPH po zľave: "
                                : "Celková cena bez DPH: "
                        }}
                        <span> {{ this.price_without_dph() }} </span>
                    </div>
                    <div class="one" v-if="this.price_without_dph() == null">
                        {{ this.Texts.oneText }}
                        <span> {{ this.price_with_dph() }} </span>
                    </div>
                    <div class="two" v-else>
                        {{ this.Texts.oneText }}
                        <span> {{ this.price_with_dph() }} </span>
                    </div>
                    <div class="three">
                        {{ this.Texts.threeText }}
                    </div>
                </div>

                <div
                    class="form-group mb-0 d-flex nezobrazit_cenu"
                    style="
                        align-items: flex-end;
                        justify-content: flex-end;
                        margin-top: 1rem;
                    "
                >
                    <input
                        v-model="show_price_box"
                        type="checkbox"
                        class="toggle"
                    />
                    <label
                        class="block mb-0"
                        @click="show_price_box = !show_price_box"
                        style="cursor: pointer"
                    >
                        Nezobraziť celkovú cenu v ponuke
                    </label>
                    <div class="info">
                        <div class="my_tooltip" style="right: 0">
                            Pri zvolení tejto možnosti v ponuke vôbec
                            nezobrazíme celkovú cenu.
                        </div>
                        <div class="tooltip_hover info_icon">
                            <img src="/img/create_offer/info.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btns">
            <div class="spat" @click="$emit('back', 1)">Späť</div>
            <div class="right">
                <span v-if="saveTime" class="automatic_save">
                    {{ saveTime }}
                </span>
                <div class="cont_view-offer" @click="$emit('preview')">
                    <div class="btn-content-holder">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0_386_1366)">
                                <path
                                    d="M0.833328 10C0.833328 10 4.16666 3.33337 10 3.33337C15.8333 3.33337 19.1667 10 19.1667 10C19.1667 10 15.8333 16.6667 10 16.6667C4.16666 16.6667 0.833328 10 0.833328 10Z"
                                    stroke="#212541"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
                                    stroke="#212541"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_386_1366">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <span> Pozrieť ponuku online </span>
                    </div>
                </div>
                <div
                    v-if="koncept == 0 && !new_offer"
                    :class="
                        'cont_save-pdf' + (pdfLoading ? ' pdf-loading' : '')
                    "
                    @click="startPdfLoading"
                >
                    <div class="btn-content-holder">
                        <span class="pdf-btn-icon">
                            <svg
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6 7.83337V11.8334L7.33333 10.5"
                                    stroke="#212541"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M6 11.8333L4.66666 10.5"
                                    stroke="#212541"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M14.6667 7.16671V10.5C14.6667 13.8334 13.3333 15.1667 10 15.1667H6C2.66667 15.1667 1.33334 13.8334 1.33334 10.5V6.50004C1.33334 3.16671 2.66667 1.83337 6 1.83337H9.33334"
                                    stroke="#212541"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M14.6667 7.16671H12C10 7.16671 9.33334 6.50004 9.33334 4.50004V1.83337L14.6667 7.16671Z"
                                    stroke="#212541"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </span>
                        <span class="pdf-btn-spinner"></span>
                        <span> Stiahnuť PDF </span>
                    </div>
                </div>
                <div v-else class="cont_save-pdf disabled">
                    <div class="my_tooltip_disabled">
                        Pre stiahnutie PDF prosím najskôr zverejni ponuku.
                    </div>
                    <div class="btn-content-holder">
                        <svg
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6 7.83337V11.8334L7.33333 10.5"
                                stroke="#212541"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M6 11.8333L4.66666 10.5"
                                stroke="#212541"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M14.6667 7.16671V10.5C14.6667 13.8334 13.3333 15.1667 10 15.1667H6C2.66667 15.1667 1.33334 13.8334 1.33334 10.5V6.50004C1.33334 3.16671 2.66667 1.83337 6 1.83337H9.33334"
                                stroke="#212541"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M14.6667 7.16671H12C10 7.16671 9.33334 6.50004 9.33334 4.50004V1.83337L14.6667 7.16671Z"
                                stroke="#212541"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <span> Stiahnuť PDF </span>
                    </div>
                </div>
                <div class="ulozit">
                    <span v-show="canSave == 1"> Ukladá sa... </span>
                    <span v-show="canSave != 1" @click="saveData(0)">
                        <div v-show="!saved0" class="ulozit_content-holder">
                            <span class="ulozit_save-icon">
                                <svg
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M15.855 4.14501L12.855 1.14501C12.8083 1.09867 12.7529 1.06201 12.692 1.03712C12.631 1.01224 12.5658 0.999628 12.5 1.00001H2.5C2.10218 1.00001 1.72064 1.15804 1.43934 1.43935C1.15804 1.72065 1 2.10218 1 2.50001V14.5C1 14.8978 1.15804 15.2794 1.43934 15.5607C1.72064 15.842 2.10218 16 2.5 16H14.5C14.8978 16 15.2794 15.842 15.5607 15.5607C15.842 15.2794 16 14.8978 16 14.5V4.50001C16.0004 4.43421 15.9878 4.36897 15.9629 4.30806C15.938 4.24714 15.9013 4.19173 15.855 4.14501ZM10.5 2.00001V5.00001H6.5V2.00001H10.5ZM4.5 15V11.5C4.5 11.3674 4.55268 11.2402 4.64645 11.1465C4.74022 11.0527 4.86739 11 5 11H12C12.1326 11 12.2598 11.0527 12.3536 11.1465C12.4473 11.2402 12.5 11.3674 12.5 11.5V15H4.5ZM15 14.5C15 14.6326 14.9473 14.7598 14.8536 14.8536C14.7598 14.9473 14.6326 15 14.5 15H13.5V11.5C13.5 11.1022 13.342 10.7207 13.0607 10.4394C12.7794 10.158 12.3978 10 12 10H5C4.60218 10 4.22065 10.158 3.93934 10.4394C3.65804 10.7207 3.5 11.1022 3.5 11.5V15H2.5C2.36739 15 2.24022 14.9473 2.14645 14.8536C2.05268 14.7598 2 14.6326 2 14.5V2.50001C2 2.3674 2.05268 2.24022 2.14645 2.14646C2.24022 2.05269 2.36739 2.00001 2.5 2.00001H5.5V5.00001C5.5 5.26523 5.60536 5.51958 5.79289 5.70712C5.98043 5.89465 6.23478 6.00001 6.5 6.00001H10.5C10.7652 6.00001 11.0196 5.89465 11.2071 5.70712C11.3946 5.51958 11.5 5.26523 11.5 5.00001V2.00001H12.295L15 4.70501V14.5Z"
                                        fill="#2ED8B6"
                                    />
                                </svg>
                            </span>
                            <span> Uložiť </span>
                        </div>
                        <div v-show="saved0" class="lds-ellipsis green">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </span>
                </div>
                <div class="save_cont" @click="saveData(1)">
                    <div v-show="!saved1" class="save_cont_holder">
                        <span> Uložiť a pokračovať </span>
                        <span class="save_cont_next-sign"
                            ><svg
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12.4934 7.5001H2.50659M8.60966 3.61633L12.4934 7.5001L8.60966 3.61633ZM12.4934 7.5001L8.60966 11.3839L12.4934 7.5001Z"
                                    stroke="#2ED8B6"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </span>
                    </div>
                    <div v-show="saved1" class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import swal from "sweetalert2/dist/sweetalert2.all.min.js";
import { EventBus } from "./components/EventBus";
import Entry from "./components/Entry.vue";
import draggable from "vuedraggable/src/vuedraggable";
import { Money } from "v-money";
import moment from "moment";
moment.locale("sk");

export default {
    props: [
        "edit_entries",
        "uuidOffer",
        "dph",
        "premium",
        "TotalPrice",
        "new_offer",
        "showStatus",
        "koncept",
        "can_load",
        "preloadedentrytitlephoto",
        "preloadedentrytitlephoto_mobile",
        "default_dph_",
        "is_paid",
    ],
    components: {
        Entry,
        draggable,
        Money,
    },
    data() {
        return {
            pdfLoading: false,
            entries_to_store: [],
            entries: [],
            values: {
                price: 0,
                price_to: null,
                price_discount: 0,
                price_to_discount: null,
                price_dph: 0,
                price_to_dph: null,
                discount: 0,
                dph: 0,
            },
            suffix: {
                discount: {
                    suffix: " %",
                    precision: 0,
                },
            },
            units: [],
            canSave: 0,
            saveTime: null,
            showDiscount: false,
            showDPH: false,
            getTariff: false,
            newTariff: 0,
            saved0: false,
            saved1: false,
            show_price_box: false,
            Texts: {
                oneText: "",
                twoText: "",
                threeText: "",
            },
            current_currency: "€",
            entries_title_image: this.preloadedentrytitlephoto
                ? JSON.parse(this.preloadedentrytitlephoto)
                : null,
            entries_title_image_mobile: this.preloadedentrytitlephoto_mobile
                ? JSON.parse(this.preloadedentrytitlephoto_mobile)
                : null,
            default_dph: "",
            cena_with_dph: 0,
            cena_do_with_dph: 0,
            cena_without_dph: 0,
            cena_do_without_dph: 0,
            cena_with_dph_discount: 0,
            cena_do_with_dph_discount: 0,
            is_total_price_with_dph: function () {
                let is_dph = false;
                this.entries_to_store.forEach((entry) => {
                    if (entry.dph > 0 && !entry.exclude) {
                        is_dph = true;
                    }
                    entry.subentries.forEach((subentry) => {
                        if (subentry.dph > 0 && !subentry.exclude) {
                            is_dph = true;
                        }
                    });
                });
                return is_dph;
            },
            price_with_dph: function () {
                let price = 0;
                let price_to = 0;
                this.entries_to_store.forEach((entry) => {
                    if (!entry.exclude) {
                        if (entry.price_type == 3) {
                            let price_subentries = 0;
                            let price_to_subentries = 0;
                            entry.subentries.forEach((subety) => {
                                if (!subety.exclude) {
                                    price_subentries +=
                                        subety.price * (1 + subety.dph / 100);
                                    price_to_subentries += subety.price_to
                                        ? subety.price_to *
                                          (1 + subety.dph / 100)
                                        : subety.price * (1 + subety.dph / 100);
                                }
                            });
                            price +=
                                price_subentries * (1 - entry.discount / 100);
                            price_to +=
                                price_to_subentries *
                                (1 - entry.discount / 100);
                        } else {
                            price += entry.price * (1 + entry.dph / 100);
                            price_to += entry.price_to
                                ? entry.price_to * (1 + entry.dph / 100)
                                : entry.price * (1 + entry.dph / 100);
                        }
                    }
                    if (entry.price_type != 3) {
                        entry.subentries.forEach((subety) => {
                            if (!subety.exclude) {
                                price += subety.price * (1 + subety.dph / 100);
                                price_to += subety.price_to
                                    ? subety.price_to * (1 + subety.dph / 100)
                                    : subety.price * (1 + subety.dph / 100);
                            }
                        });
                    }
                });
                // calculate discount
                this.cena_with_dph = price;
                this.cena_do_with_dph = price_to;
                price = price * (1 - this.values.discount / 100);
                price_to = price_to * (1 - this.values.discount / 100);
                this.cena_with_dph_discount = price;
                this.cena_do_with_dph_discount = price_to;
                if (price != price_to) {
                    return (
                        this.roundPrice(price) +
                        " " +
                        this.current_currency +
                        " - " +
                        this.roundPrice(price_to) +
                        " " +
                        this.current_currency
                    );
                } else {
                    return this.roundPrice(price) + " " + this.current_currency;
                }
            },
            price_without_dph: function () {
                let price = 0;
                let price_to = 0;
                this.entries_to_store.forEach((entry) => {
                    if (!entry.exclude) {
                        price += entry.price;
                        price_to += entry.price_to;
                    }
                    if (entry.price_type != 3) {
                        entry.subentries.forEach((subety) => {
                            if (!subety.exclude) {
                                price += subety.price;
                                price_to += subety.price_to
                                    ? subety.price_to
                                    : subety.price;
                            }
                        });
                    }
                });
                // calculate discount
                price = price * (1 - this.values.discount / 100);
                price_to = price_to * (1 - this.values.discount / 100);
                this.cena_without_dph = price;
                this.cena_do_without_dph = price_to;
                if (!this.is_total_price_with_dph()) {
                    return null;
                }
                if (price != price_to) {
                    return (
                        this.roundPrice(price) +
                        " " +
                        this.current_currency +
                        " - " +
                        this.roundPrice(price_to) +
                        " " +
                        this.current_currency
                    );
                } else {
                    return this.roundPrice(price) + " " + this.current_currency;
                }
            },
        };
    },
    created() {
        //add default first entry
        if (this.dph != "") {
            // this.showDPH = true;
            this.values.dph = 0; //this.dph;
        }
        this.getUnits();
        //this.getEntries()
    },
    methods: {
        startPdfLoading() {
            this.pdfLoading = true;
            this.$emit("downloadPdf");
            const cleanup = () => {
                this.pdfLoading = false;
                window.removeEventListener("blur", cleanup);
            };
            window.addEventListener("blur", cleanup);
            setTimeout(cleanup, 30000);
        },
        normalizeDph(dph) {
            // Convert DPH to a consistent key
            // null, undefined, 0, '' all become 'null'
            if (dph === null || dph === undefined || dph === 0 || dph === "") {
                return "null";
            }
            // Convert to number and use as string key
            const parsed = parseFloat(dph);
            return isNaN(parsed) ? "null" : parsed.toString();
        },
        createEmptyEntry() {
            this.addEntry(false);
        },
        copy_entry(id) {
            const originalEntry = this.entries.find((item) => item.id === id);
            const entry = JSON.parse(JSON.stringify(originalEntry));
            entry.data.id = null;
            entry.data.uuid = this.makeuuid(6);
            this.entries.push({
                id: this.entries.length,
                uuid: this.makeuuid(6),
                component: Entry,
                data: {},
                copied_entry: entry.data,
                title_file_mobile: this.entries_title_image_mobile
                    ? this.entries_title_image_mobile[originalEntry.data.id]
                    : null,
                title_file: this.entries_title_image
                    ? this.entries_title_image[originalEntry.data.id]
                    : null,
            });
            this.entriesChanged();
            this.$toast.success("Položka bola zduplikovaná", {
                timeout: 2038,
            });
        },
        getNextUniqueId() {
            return this.entries.length > 0
                ? Math.max(...this.entries.map((e) => e.id)) + 1
                : 1;
        },
        getUnits() {
            axios.post("/api/offer/units").then((response) => {
                this.units = response.data;
            });
        },
        makeActualSave() {
            this.canSave = 1;
            let data = this.values;
            data["entries"] = this.entries_to_store;
            data["uuidOffer"] = this.uuidOffer;

            //this.getEntries()

            let offer = {
                uuid: this.uuidOffer,
                show_price_box: this.show_price_box,
                zlava: this.showDiscount ? this.values.discount : null,
                dph: 0, //this.showDPH ? this.values.dph : null,
                cena: this.roundPrice(this.cena_with_dph),
                cena_do:
                    this.cena_with_dph != this.cena_do_with_dph
                        ? this.roundPrice(this.cena_do_with_dph)
                        : null,
                cena_zlava: this.roundPrice(this.cena_with_dph_discount),
                cena_do_zlava:
                    this.cena_with_dph_discount !=
                    this.cena_do_with_dph_discount
                        ? this.roundPrice(this.cena_do_with_dph_discount)
                        : null,
                cena_without_dph: this.roundPrice(this.cena_without_dph),
                cena_do_without_dph: this.roundPrice(this.cena_do_without_dph),
            };

            axios
                .post(`/api/offers/entries/save`, data)
                .then((response) => {
                    axios
                        .post(`/api/offers/offer/price/save`, offer)
                        .then((response) => {
                            this.canSave = 0;
                            this.saveTime =
                                "Automaticky uložené " + moment().format("LTS");
                        });
                })
                .catch(function (error) {});

            axios
                .post(`/api/offers/offer/totalPriceRow/save`, {
                    offer_uuid: this.uuidOffer,
                    price: this.TotalPrice,
                })
                .then((response) => {});
        },
        saveData(type) {
            let data = this.values;
            data["entries"] = this.entries_to_store;
            data["uuidOffer"] = this.uuidOffer;
            data["type"] = type;

            //this.getEntries()

            type == 0 ? (this.saved0 = true) : (this.saved1 = true);

            let offer = {
                uuid: this.uuidOffer,
                zlava: this.showDiscount ? this.values.discount : null,
                dph: 0, //this.showDPH ? this.values.dph : null,
                cena: this.roundPrice(this.cena_with_dph), //cena s DPH bez zlavy
                cena_do:
                    this.cena_with_dph != this.cena_do_with_dph
                        ? this.roundPrice(this.cena_do_with_dph)
                        : null, //cena s DPH bez zlavy
                cena_zlava: this.roundPrice(this.cena_with_dph_discount), //cena s DPH so zlavou
                cena_do_zlava:
                    this.cena_with_dph_discount !=
                    this.cena_do_with_dph_discount
                        ? this.roundPrice(this.cena_do_with_dph_discount)
                        : null, //cena s DPH so zlavou
                show_price_box: this.show_price_box,
                cena_without_dph: this.roundPrice(this.cena_without_dph),
                cena_do_without_dph: this.roundPrice(this.cena_do_without_dph),
            };
            axios
                .post(`/api/offers/entries/save`, data)
                .then((response) => {
                    axios
                        .post(`/api/offers/offer/price/save`, offer)
                        .then((response) => {
                            if (type == 0) {
                                setTimeout(() => {
                                    this.saved0 = false;
                                    this.canSave = 0;
                                    this.$toast.success(
                                        "Informacie boli uložené.",
                                        {
                                            position: "top-right",
                                            timeout: 2038,
                                        }
                                    );
                                    if (type == 0) {
                                        var today = new Date();
                                        this.saveTime =
                                            "Uložené " + moment().format("LTS");
                                    }
                                }, 1000);
                            } else {
                                setTimeout(() => {
                                    this.saved1 = false;
                                }, 500);
                                this.$emit("saveAndCont", data);
                            }
                        });
                })
                .catch(function (error) {});

            axios
                .post(`/api/offers/offer/totalPriceRow/save`, {
                    offer_uuid: this.uuidOffer,
                    price: this.TotalPrice,
                })
                .then((response) => {});
        },
        calcuate() {
            this.entries_to_store = [];
            //uloženie podpoložiek
            this.entries.forEach((ety) => {
                if (ety.data.type != null) {
                    let one = {};
                    //check type
                    switch (ety.data.type.id) {
                        case 0:
                            one = this.cal_type_zero(ety.data);
                            one["subentries"] = this.subentries_to_rdy(
                                ety.data
                            );
                            break;

                        case 1:
                            one = this.cal_type_one(ety.data);
                            one["subentries"] = this.subentries_to_rdy(
                                ety.data
                            );
                            break;

                        case 2:
                            one = this.cal_type_two(ety.data);
                            one["subentries"] = this.subentries_to_rdy(
                                ety.data
                            );
                            break;

                        case 3:
                            one = this.cal_type_three(ety.data);
                            one["subentries"] = this.subentries_to_rdy(
                                ety.data
                            );
                            break;

                        case 4:
                            one = this.cal_type_four(ety.data);
                            one["subentries"] = this.subentries_to_rdy(
                                ety.data
                            );
                            break;
                    }
                    (one["price"] = ety.data.price),
                        (one["price_to"] = ety.data.price_to),
                        (one["price_to_discount"] = ety.data.price_to_discount),
                        (one["price_discount"] = ety.data.price_discount),
                        (one["discount"] = ety.data.values.discount),
                        (one["name"] = ety.data.name);
                    one["text"] = ety.data.text;
                    one["inter_note"] = ety.data.inter_note;
                    one["files"] = ety.data.files;
                    one["id"] = ety.data.id;
                    one["uuid"] = ety.data.uuid;
                    one["discount_type"] = ety.data.discount_type;
                    one["dph"] = ety.data.dph;
                    one["exclude"] = 0;
                    one["price_without_discount"] =
                        ety.data.price_without_discount;
                    one["price_to_without_discount"] =
                        ety.data.price_to_without_discount;
                    if (ety.data.exclude) one["exclude"] = 1;
                    one["line"] = ety.id;
                    this.entries_to_store.push(one);
                }
            });
            this.cal_price();
        },
        roundPrice(price, digits = 2) {
            return parseFloat(Math.round(price * 100) / 100).toFixed(digits);
        },
        //cena text
        price_text() {
            //celkova cena
            var zlava = parseFloat(
                Math.round(
                    (this.cena_with_dph - this.cena_with_dph_discount) * 100
                ) / 100
            );
            var zlava_to = parseFloat(
                Math.round(
                    (this.cena_do_with_dph - this.cena_do_with_dph_discount) *
                        100
                ) / 100
            );
            if (this.cena_do_with_dph == this.cena_with_dph) {
                this.Texts.oneText = "Celková cena: ";
                if (this.is_total_price_with_dph()) {
                    this.Texts.oneText = "Celková cena s DPH: ";
                }
                this.Texts.twoText = "";
                this.Texts.threeText = "";

                //celkova cena + zlava
                if (this.showDiscount) {
                    this.Texts.oneText = "Celková cena po zľave: ";
                    if (this.is_total_price_with_dph()) {
                        this.Texts.oneText = "Celková cena s DPH po zľave: ";
                    }
                    this.Texts.threeText =
                        "Zľava: " + zlava + " " + this.current_currency;
                }
                //celkova cena + dph
                if (this.showDPH) {
                    //celkova cena + dph + zlava
                    if (this.showDiscount) {
                        this.Texts.oneText = "Celková cena po zľave bez DPH: ";
                        this.Texts.twoText = "Celková cena po zľave s DPH: ";
                        this.Texts.threeText =
                            "Zľava: " + zlava + " " + this.current_currency;

                        //celkova cena + dph
                    } else {
                        this.Texts.oneText = "Celková cena bez DPH: ";
                        this.Texts.twoText = "Celková cena s DPH: ";
                    }
                }
                //celkova cena od - do
            } else {
                this.Texts.oneText = "Celková cena: ";
                if (this.is_total_price_with_dph()) {
                    this.Texts.oneText = "Celková cena s DPH: ";
                }
                this.Texts.twoText = "";
                this.Texts.threeText = "";
                if (this.showDiscount) {
                    this.Texts.oneText = "Celková cena po zľave: ";
                    if (this.is_total_price_with_dph()) {
                        this.Texts.oneText = "Celková cena s DPH po zľave: ";
                    }
                    this.Texts.threeText =
                        "Zľava: " +
                        zlava +
                        " " +
                        this.current_currency +
                        " - " +
                        zlava_to +
                        " " +
                        this.current_currency;
                }
                //celkova cena od - do + dph od - do
                if (this.showDPH) {
                    //celkova cena od - do + dph od - do + zlava od - do
                    if (this.showDiscount) {
                        this.Texts.oneText = "Celková cena po zľave bez DPH: ";
                        if (this.is_total_price_with_dph()) {
                            this.Texts.oneText =
                                "Celková cena po zľave s DPH: ";
                        }
                        this.Texts.twoText = "Celková cena po zľave s DPH: ";
                        this.Texts.threeText =
                            "Zľava: " +
                            zlava +
                            " " +
                            this.current_currency +
                            " - " +
                            zlava_to +
                            " " +
                            this.current_currency;

                        //celkova cena od - do + dph od - do
                    } else {
                        this.Texts.oneText = "Celková cena bez DPH: ";
                        if (this.is_total_price_with_dph()) {
                            this.Texts.oneText = "Celková cena s DPH: ";
                        }
                        this.Texts.twoText = "Celková cena s DPH: ";
                    }
                }
            }
            if (this.price_with_dph() != null) {
                this.$emit("setPrice", this.price_with_dph());
            } else if (this.price_without_dph() != null) {
                this.$emit("setPrice", this.price_without_dph());
            } else {
                this.$emit("setPrice", this.roundPrice(this.cena_with_dph));
            }
        },
        //vypočitanie ceny cena
        cal_price() {
            this.price_with_dph();
            this.price_without_dph();
            this.price_text();
        },
        //0 - hodinovka
        cal_type_zero(item) {
            let one = {
                //jednotka
                unit: "hodiny",
                //počet jednotiek
                pocet: item.values.number_of,
                //počet do
                pocet_do: null,
                //sadzba
                sadzba: item.values.tariff,
                //cena_type
                price_type: item.type.id,
            };
            return one;
        },
        //1 - od - do
        cal_type_one(item) {
            let one = {
                //jednotka
                unit: "hodiny",
                //počet jednotiek
                pocet: null,
                //počet do
                pocet_do: null,
                //sadzba
                sadzba: null,
                //cena_type
                price_type: item.type.id,
            };
            return one;
        },
        //2 - vlastna
        cal_type_two(item) {
            let one = {
                //jednotka
                unit: item.unit,
                //počet jednotiek
                pocet: item.values.number_of,
                //počet do
                pocet_do: null,
                //sadzba
                sadzba: item.values.tariff,
                //cena_type
                price_type: item.type.id,
            };
            return one;
        },
        //3 - cena z podpoložiek
        cal_type_three(item) {
            let one = {
                //jednotka
                unit: null,
                //počet jednotiek
                pocet: null,
                //počet do
                pocet_do: null,
                //sadzba
                sadzba: null,
                //cena_type
                price_type: item.type.id,
            };
            return one;
        },
        //4 - hodiny od - do
        cal_type_four(item) {
            let one = {
                //jednotka
                unit: "hodiny",
                //počet jednotiek
                pocet: item.values.number_of,
                //počet do
                pocet_do: item.values.number_of_to,
                //sadzba
                sadzba: item.values.tariff,
                //cena_type
                price_type: item.type.id,
            };
            return one;
        },
        //------pripravenie podpoložiek na uloženie----
        subentries_to_rdy(ety) {
            let is_from_to = false;
            let subEntries = [];
            if (ety.subEntries.length) {
                ety.subEntries.forEach((sub) => {
                    if (sub.data.type != null) {
                        let one = {};
                        //check type
                        switch (sub.data.type.id) {
                            case 0:
                                one = this.cal_type_zero(sub.data);
                                break;

                            case 1:
                                one = this.cal_type_one(sub.data);
                                is_from_to = true;
                                break;

                            case 2:
                                one = this.cal_type_two(sub.data);
                                break;

                            case 3:
                                this.cal_type_three(sub.data);
                                break;

                            case 4:
                                one = this.cal_type_four(sub.data);
                                is_from_to = true;
                                break;
                        }
                        //cena
                        (one["price"] = sub.data.price),
                            //cena_do
                            (one["price_to"] = sub.data.price_to),
                            //cena_zlava_do
                            (one["price_to_discount"] =
                                sub.data.price_to_discount),
                            //cena_zlava
                            (one["price_discount"] = sub.data.price_discount),
                            //zlava
                            (one["discount"] = sub.data.values.discount),
                            //nazov
                            (one["name"] = sub.data.name);
                        //text
                        one["text"] = sub.data.text;
                        //dph
                        one["dph"] =
                            parseFloat(sub.data.dph) == null ||
                            parseFloat(sub.data.dph) == NaN
                                ? 0
                                : parseFloat(sub.data.dph);
                        //nepočitať
                        one["exclude"] = 0;
                        if (sub.data.exclude) one["exclude"] = 1;
                        //line
                        one["line"] = sub.id;
                        //pushnutie do vysledneho arrayu ponuk
                        subEntries.push(one);
                    }
                });
            }
            return subEntries;
        },
        //------entry functions------------------
        entriesChanged() {
            this.canSave = 2;
            this.sortEntry();
            this.calcuate();
            this.$emit("getEntires", this.entries_to_store);
        },
        moveUp(index) {
            if (index > 0) {
                const temp = this.entries[index - 1];
                this.entries.splice(index - 1, 1, this.entries[index]);
                this.entries.splice(index, 1, temp);
                this.entriesChanged();
            }
            $(".my_tooltip").css("opacity", "0");
        },

        moveDown(index) {
            if (index < this.entries.length - 1) {
                const temp = this.entries[index + 1];
                this.entries.splice(index + 1, 1, this.entries[index]);
                this.entries.splice(index, 1, temp);
                this.entriesChanged();
            }
            $(".my_tooltip").css("opacity", "0");
        },
        dataEntry(value, id) {
            this.entries[id].data = value;
            this.entriesChanged();
        },
        sortEntry() {
            for (let index = 0; index < this.entries.length; index++) {
                this.entries[index].id = index;
            }
        },
        addEntry(type) {
            this.entries.push({
                id: this.entries.length,
                uuid: this.makeuuid(6),
                component: Entry,
                data: {},
            });
            this.getTariff = false;
            if (type) {
                if (this.entries_to_store.length > 0) {
                    this.newTariff =
                        this.entries_to_store[
                            this.entries_to_store.length - 1
                        ].sadzba;
                    if (this.newTariff > 0) this.getTariff = true;
                }
            }
            //this.getEntries()
            this.entriesChanged();
            setTimeout(() => {
                this.getTariff = false;
            }, 500);
        },
        removeEntryWithoutClick(id) {
            const index = this.entries.findIndex((f) => f.id === id);
            this.entries.splice(index, 1);
            this.entriesChanged();
            this.getTariff = false;
        },
        removeEntry(id) {
            swal.fire({
                title: "Určite?",
                text: "Naozaj chceš vymazať túto položku?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Nie",
                confirmButtonText: "Áno",
            }).then((result) => {
                if (result.value) {
                    const index = this.entries.findIndex((f) => f.id === id);
                    axios
                        .post(`/api/offers/entries/remove`, {
                            entry_id: this.entries[index].data.id,
                            entry_uuid: this.entries[index].data.uuid,
                        })
                        .then((response) => {
                            this.entries.splice(index, 1);
                            this.entriesChanged();
                            this.getTariff = false;
                        });
                }
            });
        },
        makeuuid(length) {
            var result = "";
            var characters =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                );
            }
            return result;
        },
        //-----------end entry functions---------
    },
    mounted() {
        setInterval(() => {
            if (this.showStatus == 2)
                if (this.canSave == 2) this.makeActualSave();
        }, 10000);
        EventBus.$on("currencyChanged", (val) => {
            this.current_currency = val;
        });
        EventBus.$on("mojafirma_dph", (val) => {
            if (this.new_offer) {
                this.default_dph =
                    val == "" || val == null || val == undefined
                        ? 0
                        : parseFloat(val);
            }
        });
        setTimeout(() => {
            const iframe = document.querySelector(
                ".helpcrunch-iframe-wrapper iframe"
            );
            iframe.style.bottom = "63px";
        }, 3000);
    },
    watch: {
        current_currency: function () {
            this.price_text();
        },
        can_load: function () {
            if (this.can_load) {
                //this.getEntries();
            }
        },
        "edit_entries.offerData": function () {
            if (this.edit_entries.offerData.zlava != null) {
                this.showDiscount = true;
                this.values.discount = this.edit_entries.offerData.zlava;
            }
            if (this.edit_entries.offerData.dph != null) {
                // this.showDPH = true;
                this.values.dph = this.edit_entries.offerData.dph;
            }
            this.show_price_box =
                this.edit_entries.offerData.show_price_box == 1 ? true : false;
            this.cal_price();
        },
        "edit_entries.new_entries": function () {
            this.removeEntryWithoutClick(0);
            if (this.edit_entries.new_entries.length >= 1) {
                for (let i = 0; i < this.edit_entries.new_entries.length; i++) {
                    this.addEntry(false);
                }
            }
        },
        values: {
            handler: function (newval) {
                this.canSave = 2;
            },
            deep: true,
        },
        "values.discount": function () {
            this.cal_price();
        },
        "values.dph": function () {
            this.cal_price();
        },
        default_dph_: function () {
            if (this.default_dph_ != "" && this.new_offer) {
                this.default_dph = this.default_dph_;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.automatic_save {
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 19px;
    color: #9598a7;
    margin-right: 21px;

    @media (max-width: 600px) {
        margin-right: 0 !important;
    }
}

.ulozene {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #2ed8b6;
}

a {
    text-decoration: none;

    .premium-info {
        width: 596px;
        height: 41px;
        background: #fff7ed;
        border: 1px solid #fbbf24;
        box-sizing: border-box;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 18px 0;

        @media (max-width: 620px) {
            display: grid;
            padding: 15px 10px;
            height: auto;
            width: 100%;
        }

        img {
            margin-right: 8px;

            @media (max-width: 620px) {
                margin: 0 auto 10px auto;
            }
        }

        div {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            color: #9a3412;
        }

        b {
            &:last-child {
                text-decoration: underline;
            }
        }
    }
}

.cont {
    .mobile_doba_inputs {
        @media (max-width: 550px) {
            display: grid !important;
        }

        label {
            @media (max-width: 600px) {
                width: 70%;
            }
        }
    }

    .doba_inputs {
        width: 250px;

        @media (max-width: 550px) {
            margin: 20px 0 !important;
        }

        input {
            height: 50px;
        }
    }

    .add_entry {
        width: 100%;
        height: 50px;
        background: #212541;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        color: #fff;
        cursor: pointer;
    }

    label {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #212541;
    }

    input[type="checkbox"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
        margin: 0px 10px 0 0px;
        background: #c7d4eb;
        border-radius: 25px;
    }

    .toggle {
        height: 22px;
        width: 40px;
        display: inline-block;
        position: relative;
        margin: 0;
        border: none;
        background: #ffffff;
        border-radius: 3px;
        transition: all 0.2s ease;

        &:focus {
            outline: 0;
        }

        &:after {
            content: "";
            position: absolute;
            top: 4px;
            left: 3px;
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background: white;
            box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
            transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
        }

        &:checked {
            border-color: #2ed8b6;
            background: #2ed8b6;
        }

        &:checked:after {
            transform: translatex(20px);
        }
    }

    .nezobrazit_cenu .my_tooltip {
        &::after {
            left: unset !important;
            right: 3px !important;
        }
    }

    .form-group,
    .absolute_container {
        .info {
            height: 20px;
            position: relative;
            margin-left: 8px;

            .info_icon {
                pointer-events: all;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                float: right;

                img {
                    width: 80%;
                    height: 80%;
                }
            }

            .my_tooltip {
                @media (max-width: 1200px) {
                    width: auto;
                    min-width: 180px;
                    right: 0;
                }

                pointer-events: none;
                opacity: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 300px;
                background: #f3385a;
                box-sizing: border-box;
                box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
                border-radius: 5px;
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 18px;
                text-align: center;
                color: #fff;
                padding: 10px;
                position: absolute;
                bottom: 25px;
                right: -140px;
                z-index: 10000;
                transition: opacity 0.5s ease-in-out;

                &::after {
                    @media (max-width: 1200px) {
                        left: unset;
                        right: 3px;
                    }

                    content: "";
                    width: 15px;
                    height: 15px;
                    background: #f3385a;
                    position: absolute;
                    right: 0;
                    left: 0;
                    margin: auto;
                    bottom: -3px;
                    transform: rotate(45deg);
                    border-radius: 3px;
                }

                &.left {
                    left: 0px;
                    right: unset;

                    &::after {
                        left: 4px;
                        right: unset;
                    }
                }
            }
        }

        .zlava {
            width: 36px;
            border: none;
            background: transparent;
            border-bottom: 1px solid #212541;
            font-family: Roboto;
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
        }
    }

    .bottom {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-top: 30px;
        margin-bottom: 120px;

        @media (max-width: 1200px) {
            display: grid;
            justify-content: unset;
        }

        .left {
            .form-group {
                @media (max-width: 1200px) {
                    margin-bottom: 15px !important;
                }
            }
        }

        .right {
            @media (max-width: 1200px) {
                display: grid;
            }

            .top {
                display: flex;
                justify-content: flex-end;
                margin-bottom: 20px;

                @media (max-width: 1200px) {
                    display: grid;
                }

                .form-group {
                    @media (max-width: 1200px) {
                        margin-bottom: 15px !important;
                        margin-left: 0px !important;
                    }
                }
            }

            .price {
                margin-top: 20px;
                font-family: Roboto;
                font-style: normal;
                color: #212541;
                text-align: right;

                .one {
                    font-size: 24px;
                    font-weight: 500;
                    line-height: 28px;

                    span {
                        font-weight: 700;
                    }

                    @media (max-width: 400px) {
                        font-size: 18px;
                    }
                }

                .two {
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 16px;
                    margin-top: 8px;

                    span {
                        font-weight: 700;
                    }
                }

                .three {
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 16px;
                    margin-top: 8px;
                }
            }
        }
    }

    .btns {
        padding: 10px 18px 10px 18px;
        width: 100%;
        display: flex;
        align-items: center;
        box-shadow: 0px 4px 15px 0px #0000000d;
        justify-content: space-between;
        border-top: 1px solid #dadada;
        box-shadow: 0px -4px 15px rgba(0, 0, 0, 0.05);
        background: #fff;

        position: fixed;
        left: 65px;
        width: calc(100% - 65px);
        z-index: 1000;
        bottom: 0;

        @media (max-width: 600px) {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .spat {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            width: 103px;
            height: 55px;
            border: 1px solid #dde3e8;
            box-sizing: border-box;
            border-radius: 4px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            color: #212541;

            @media (max-width: 600px) {
                width: 80px;
                margin-bottom: 10px !important;
            }
        }

        .right {
            display: flex;
            align-items: center;

            @media (max-width: 600px) {
                flex-direction: column;
                gap: 10px;
            }

            .ulozit {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                margin-left: 12px;
                width: 103px;
                height: 55px;
                border: 1px solid #2ed8b6;
                box-sizing: border-box;
                border-radius: 4px;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 16px;
                line-height: 19px;
                text-align: center;
                color: #2ed8b6;

                @media (max-width: 500px) {
                    width: 180px;
                    margin: 0 !important;
                }
            }

            .save_cont {
                margin-left: 12px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                width: 200px;
                height: 55px;
                background: #2ed8b6;
                box-sizing: border-box;
                border-radius: 4px;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 16px;
                line-height: 19px;
                text-align: center;
                color: #ffffff;

                @media (max-width: 500px) {
                    width: 180px;
                    margin-left: 0;
                }
            }
        }
    }
}

.absolute_container {
    position: absolute;

    .arrow_container {
        display: flex;
        align-items: center;
        justify-content: center;

        .arrow_up,
        .arrow_down {
            height: 20px;
            width: 20px;
            cursor: pointer;
        }

        .arrow_up {
            rotate: 180deg;
        }

        @media (min-width: 1200px) {
            .arrow_up,
            .arrow_down {
                height: 15px;
                width: 15px;
            }
        }
    }
}

.arrow_up_container {
    top: 10px;
    left: 6.5px;
}

.arrow_down_container {
    top: 90px;
    left: 8px;
}

@media (max-width: 1200px) {
    .arrow_up_container {
        top: 10px;
        left: 4%;
    }

    .arrow_down_container {
        top: 12px;
        left: 75%;
    }
}

.o-xs {
    opacity: 35%;
}

.not-allowed-cursor {
    cursor: not-allowed !important;
}

.lds-ring {
    display: inline-block;
    position: relative;
    width: 25px;
    height: 17px;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    margin: 1px;
    margin-left: 5px;
    border: 1px solid #2ed8b6;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #2ed8b6 transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.lds-ellipsis.green div {
    background: #2ed8b6;
}

.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(0);
    }
}

@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(24px, 0);
    }
}

/**************************
    NEW CODE
 *************************/
.ulozit_content-holder {
    display: flex;
    align-items: center;
}

.ulozit_save-icon {
    margin-right: 5px;
}

.save_cont:hover .save_cont_next-sign {
    transform: translate(5px, 0);
}

.save_cont_holder {
    display: flex;
    align-items: center;
}

.btn-content-holder {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.save_cont_next-sign {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 50%;
    width: 23px;
    height: 23px;
    margin-left: 9px;
    transition: all 0.15s ease-in-out;
}

.cont_view-offer {
    width: 236px;
    height: 55px;
    background: #f7f8f8;
    color: #212541;
    margin-left: 12px;
    cursor: pointer;

    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;

    svg {
        margin-right: 4px;
    }
}

.cont_save-pdf {
    margin-left: 12px;
    cursor: pointer;

    width: 168px;
    height: 55px;
    background: #f3f4f6;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #212541;
    cursor: pointer;

    svg {
        margin-right: 4px;
    }

    .pdf-btn-spinner {
        display: none;
        width: 14px;
        height: 14px;
        border: 2px solid #212541;
        border-top-color: transparent;
        border-radius: 50%;
        animation: cont-pdf-spin 0.7s linear infinite;
        flex-shrink: 0;
        margin-right: 4px;
    }

    &.pdf-loading {
        opacity: 0.6;
        pointer-events: none;

        .pdf-btn-icon {
            display: none;
        }

        .pdf-btn-spinner {
            display: inline-block;
        }
    }

    &.disabled {
        position: relative;
        cursor: not-allowed;
        color: #21254155;

        svg {
            opacity: 0.5;
        }

        &:hover {
            .my_tooltip_disabled {
                opacity: 1;
            }
        }

        .my_tooltip_disabled {
            @media (max-width: 1200px) {
                width: auto;
                min-width: 180px;
                right: 0;
            }

            pointer-events: none;
            opacity: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 300px;
            background: #f3385a;
            box-sizing: border-box;
            box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 18px;
            text-align: center;
            color: #fff;
            padding: 10px;
            position: absolute;
            bottom: 60px;
            right: 0;
            z-index: 10000;
            transition: opacity 0.5s ease-in-out;

            &::after {
                @media (max-width: 1200px) {
                    left: unset;
                    right: 3px;
                }

                content: "";
                width: 15px;
                height: 15px;
                background: #f3385a;
                position: absolute;
                right: 5px;
                margin: auto;
                bottom: -3px;
                transform: rotate(45deg);
                border-radius: 3px;
            }
        }
    }
}

@keyframes cont-pdf-spin {
    to {
        transform: rotate(360deg);
    }
}

.cont_action-link {
    text-decoration: underline;
    color: rgba(#212541, 0.25);
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
}
</style>
